<template v-if="list.length">
  <div class="responses-list">
    <table class="vcv-table">
      <table-head v-bind="{ ...$attrs, ...$props }" v-on="$listeners" />

      <tbody>
        <tr v-if="!list.length">
          <td colspan="99" class="no-records">{{ $tr('common.noRecords') }}</td>
        </tr>

        <response-row
          v-if="list.length"
          v-for="(item, index) in list"
          :model="item"
          :key="index"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
  import TableHead from './tablehead/TableHead'
  import ResponseRow from './Row'

  // TODO: модалка не используется на странице
  // import Modal from '@/components/Modal.vue'

  export default {
    name: 'responses-list',

    components: {
      TableHead,
      ResponseRow,
      // TODO: модалка не используется на странице
      // Modal
    },
    props: {
      list: Array,
    },
    computed: {
      // TODO: company, company_id, personal_manager, personal_manager_phone не используются на странице, проверить и вероятно удалить (или перенести)
      company() {
        return this.$store.getters['company/one']
      },

      company_id() {
        if (!this.company) {
          return null
        }

        return this.company.id
      },

      personal_manager() {
        return this.$store.getters['managers/manager']
      },

      personal_manager_phone() {
        if (!this.personal_manager) {
          return ''
        }

        return this.personal_manager.phone
      }
    }
  }
</script>

<style lang="scss" scoped>
  .vcv-table {
    height: 100%;
    margin-left: -24px;
    margin-right: -24px;
    width: calc(100% + 48px);
    position: relative;
    z-index: 1;

    ::v-deep {
      th {
        position: static;
        position: sticky;
        top: 138px;
        background-color: #FFF;
        z-index: 3;

        &:after {
          width: 100%;
          height: 1px;
          background-color: #e5e5e5;;
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }
  }
  // .modal-wrap {
  //   position: relative;
  //   top: 60px;
  // }
</style>
